import axios from "axios";
import apiConfig from "../ApiConfig/apiConfig";
import { ApolloClient, InMemoryCache } from "@apollo/client"
import { QueryType } from "../Helper/constants";
import { InsuranceItem } from "../Pages/HospitalMaintenance/types/hospital.types";
const baseUri = apiConfig.api.baseURL;
// const baseUri = 'http://localhost:3081'
const urls = {
  User_URI: `${baseUri}/auth/api/v1`,
  // User_URI: `http://localhost:3002/auth/api/v1`,
  Ticket_URI: `${baseUri}/ticket/api/v1`,
  OZONETEL_URI: `${baseUri}/ozonetel/api/v1`,
  BENEFICIARY_URI: `${baseUri}/beneficiary/api/v1/beneficiary`,
  Subscriber_URI: `${baseUri}/beneficiary/api/v1/subscriber`,
  // BENEFICIARY_URI: `http://localhost:3001/beneficiary/api/v1/beneficiary`,
  Hospital_URI: `${baseUri}/hospital/api/v1`,
  //Hospital_URI: "http://localhost:3005/hospital/api/v1",
  Whatsapp_URI: `${baseUri}/whatsapp/api/v1`,
  // Whatsapp_URI: `http://localhost:3001/whatsapp/api/v1`,
  AZURE_URI: `${baseUri}/azure/api/v1`,
  SSE_URI: `${baseUri}/ticket/api/v1`,
  CALL_URI: `${baseUri}/call/api/v1`,
  OPS_URI: `${baseUri}/ops/api/v1`,
  //OPS_URI: "http://localhost:3004/ops/api/v1",
  GRAPHQL_URI: `${baseUri}/beneficiary/api/v1/graphql`,
  COMPANY_URI: `${baseUri}/company/api/v1/company-service`,
  // COMPANY_URI: `http://localhost:3091/company/api/v1/company-service`,
  EXCEL_DOWNLOAD_URI: `${baseUri}/beneficiary/api/v1`,
  // GRAPHQL_URI:`http://localhost:3081/api/v1/graphql`
  EMAIL_URI: `${baseUri}/email/api/v1`,
  //EMAIL_URI: `http://localhost:3032/email/api/v1`,
  PAYMENT_URI: `${baseUri}/payment/api/v1`,
  //PAYMENT_URI: `http://localhost:3009/payment/api/v1`,
  BACKEND_JOBS_URI: `${baseUri}/backendjobs/api/v1`
};

const axiosInstance = axios.create({
  baseURL: "",
  withCredentials: true,
  headers: {
    "content-type": "application/json",
    Accept: "application/json",

  },
});

///api-endpoint/////
/// auth-user-service
export const agentLoginFn = (payload: any) =>
  axiosInstance.post(`${urls.User_URI}/auth/poco-user-login`, payload);

export const adminUserLogout = () => axiosInstance.get(`${urls.User_URI}/auth/poco-admin-user-logout`);


///benService//ops-service//
export const getBenData = (companyId: string) => axiosInstance.get(`${urls.BENEFICIARY_URI}/search-company-beneficiaries/${companyId}`)
export const benAddressData = (payload: any) => axiosInstance.get(`${urls.BENEFICIARY_URI}/get-ben-by-filter?benName=${payload.benName}&benMobile=${payload.benMobile}&benEmail=${payload.benEmail}&company=${payload.company}&benType=${payload.subType}&pageSize=${payload.pageSize}&pageNumber=${payload.pageNumber}`)
export const printingData = () => axiosInstance.get(`${urls.OPS_URI}/printing`);
export const getSingleJob = (jobid: string) => axiosInstance.get(`${urls.OPS_URI}/printing/${jobid}`);
export const deleteBenFromJob = (jobid: string, id: string) => axiosInstance.delete(`${urls.OPS_URI}/printing/deleteBeneficiary/${jobid}`, { data: { id } });
export const addBenToJob = (jobid: string, payload: any) => axiosInstance.post(`${urls.OPS_URI}/printing/addBeneficiary/${jobid}`, payload);
export const updateBenStatus = (payload: any) => axiosInstance.patch(`${urls.OPS_URI}/printing/updateBenStatus`, payload);
export const updateJobStatus = (jobid: string, payload: any) => axiosInstance.patch(`${urls.OPS_URI}/printing/UpdateJob/${jobid}`, payload);
export const createJob = (payload: any) => axiosInstance.post(`${urls.OPS_URI}/printing`, payload);
export const graphQlPost = (query: any) => axiosInstance.post(`${urls.GRAPHQL_URI}`, query);
export const updateUserByExcel = (payload: any) => axiosInstance.post(`${urls.BENEFICIARY_URI}/update-user-by-excel`, payload)
export const handleExcelSheet = (payload: any) => axiosInstance.post(`${urls.BENEFICIARY_URI}/handle-excel-sheet`, payload)
export const searchQuery = (payload: any) => axiosInstance.get(`${urls.BENEFICIARY_URI}/search-query`, { params: payload })
export const multipleSearchQuery = (payload: any) => axiosInstance.post(`${urls.BENEFICIARY_URI}/multiple-search-query`, { data: payload })
export const downloadBenDashBoardExcel = () => axiosInstance.get(`${urls.EXCEL_DOWNLOAD_URI}/bendata-excel`, { responseType: 'blob', })
export const IdentifyUsersToDelete = (payload: any) => axiosInstance.post(`${urls.BENEFICIARY_URI}/identify-user-to-delete-by-excel`, payload, {
  headers: {
    'Content-Type': 'multipart/form-data',
  }
})
export const IdentifyUsersToAdd = (payload: any) => axiosInstance.post(`${urls.BENEFICIARY_URI}/identify-user-to-add-by-excel`, payload, {
  headers: {
    'Content-Type': 'multipart/form-data',
  }
})

//Invoice
export const getAllInvoices = async (query: string) => await axiosInstance.get(`${urls.OPS_URI}/invoice/get-invoices?${query}`);
export const getAllInvoicesForDownload = async (query: string) => await axiosInstance.get(`${urls.OPS_URI}/invoice/get-invoices/download-all?${query}`, { responseType: 'blob' });


export const downLoadInvoice = async (invoiceId: string) => await axiosInstance.get(`${urls.PAYMENT_URI}/invoice/generate-invoice/${invoiceId}`, { responseType: 'blob' })
export const sendInvoiceEmail = async (invoiceId: string, email: string) => await axiosInstance.post(`${urls.OPS_URI}/invoice/send-invoice-email`, { invoiceId, email })
//export const downLoadBulkInvoices = async (payload: { pocoOrderIds: string[]}) => await axiosInstance.post(`${urls.PAYMENT_URI}/invoice/get-bulk-invoices`, payload, { responseType: 'blob' })
export const typesAndStatus = async () => await axiosInstance.get(`${urls.PAYMENT_URI}/poco-orders/get-order-types`)
export const subscriptionDetails = async (params?: Record<string, any>) => await axiosInstance.get(`${urls.PAYMENT_URI}/subscription-report`, { params })
export const createOfflinePayment = async (payload: any) => await axiosInstance.post(`${urls.PAYMENT_URI}/poco-orders/offline-payment`, payload)

// Refund APIs
export const initiateRefund = async (payload: { order_ref_id: string; amount?: number; reason?: string }) =>
  await axiosInstance.post(`${urls.PAYMENT_URI}/refund/initiate`, payload);

export const getRefundsByTicketId = async (ticketId: string) =>
  await axiosInstance.get(`${urls.PAYMENT_URI}/refund/by-ticket/${ticketId}`);

export const getRefundsByOrderRefId = async (orderRefId: string) =>
  await axiosInstance.get(`${urls.PAYMENT_URI}/refund/by-order/${orderRefId}`);

export const syncRefundStatus = async (refundId: string) =>
  await axiosInstance.get(`${urls.PAYMENT_URI}/refund/sync/${refundId}`);

export const downloadRefundCreditNote = async (refundId: string) =>
  await axiosInstance.get(`${urls.PAYMENT_URI}/invoice/generate-refund-credit-note/${refundId}`, { responseType: 'blob' });
//WaBulkMsg///
export const sendBulk = (payload: { jobId: string }) => axiosInstance.post(`${urls.Whatsapp_URI}/send-bulk-msg/send-bulk`, payload);
export const createWaJob = (jobName: string) => axiosInstance.post(`${urls.OPS_URI}/whatsapp-bulk-msg/create-job/${jobName}`)
export const getAllWaJob = () => axiosInstance.get(`${urls.OPS_URI}/whatsapp-bulk-msg`);
export const getWaJobById = (jobId: string) => axiosInstance.get(`${urls.OPS_URI}/whatsapp-bulk-msg/${jobId}`);
export const getWaJobUserDataById = (id: string, page?: number, limit?: number) => axiosInstance.get(`${urls.OPS_URI}/whatsapp-bulk-msg/get-job-user-data/${id}?limit=${limit}&page=${page}`);
export const addBenToWhatsAppJobHttp = ({ jobId, payload }: { jobId: string, payload: { queryType: QueryType, query: Object } }) => axiosInstance.patch(`${urls.OPS_URI}/whatsapp-bulk-msg/add-user-job/${jobId}`, payload)
export const updateWaJobById = (jobId: string, payload: any) => axiosInstance.patch(`${urls.OPS_URI}/whatsapp-bulk-msg/${jobId}`, payload);
export const getBenList = (benIds: any) => axiosInstance.post(`${urls.OPS_URI}/whatsapp-bulk-msg/get-ben-list`, benIds);
export const replaceBenWithSubscriber = (jobId: string) => axiosInstance.patch(`${urls.OPS_URI}/whatsapp-bulk-msg/replace-ben-with-subscriber/${jobId}`);
export const whatsappMsgDeliveryStatus = (waId: string, page: number) => axiosInstance.get(`${urls.OPS_URI}/whatsapp-bulk-msg/wa-job-status/${waId}?page=${page}`);
export const updateWhatsappMsgDeliveryStatus = (waId: string) => axiosInstance.get(`${urls.OPS_URI}/whatsapp-bulk-msg/update-wa-job-status/${waId}`);
export const deleteBulkWaJobUserData = (jobId: string) => axiosInstance.delete(`${urls.OPS_URI}/whatsapp-bulk-msg/delete-job-user-data/${jobId}`)
export const deleteSingleUserFromBulkWhatsAppUserData = (jobId: string, benId: string) => axiosInstance.delete(`${urls.OPS_URI}/whatsapp-bulk-msg/delete-user-from-job/${jobId}/${benId}`)
export const deleteInvalidPhonesBulkWhatSAppJobUserData = (jobId: string) => axiosInstance.delete(`${urls.OPS_URI}/whatsapp-bulk-msg/delete-invalid-PhNumber-job-user-data/${jobId}`)
export const deleteDuplicatePhonesBulkWhatSAppJobUserData = (jobId: string) => axiosInstance.delete(`${urls.OPS_URI}/whatsapp-bulk-msg/remove-duplicate/${jobId}`)
////whatsapp//
export const whatsappConfiguration = () => axiosInstance.get(`${urls.Whatsapp_URI}/send-bulk-msg/get-all-bulk-templates`);
export const getWaTemplateDetails = (serviceName: string, templateName: string) => axiosInstance.get(`${urls.Whatsapp_URI}/send-bulk-msg/${serviceName}/${templateName}`);
export const sendWhatsappMsg = (payload: any) => axiosInstance.post(`${urls.Whatsapp_URI}/whatsapp`, payload);

export const getWhatsappTemplate = (page: number) => axiosInstance.get(`${urls.Whatsapp_URI}/configurations/bulk?page=${page}`);
export const addTemplateHttp = (payload: any) => axiosInstance.patch(`${urls.Whatsapp_URI}/configurations/addTemplate`, payload);
export const uploadWhatsappMediaHttp = (file: File) => {
  const form = new FormData();
  form.append('file', file);
  form.append('docFolder', 'whatsapp-templates');
  form.append('docName', file.name);
  return axiosInstance.post(`${urls.AZURE_URI}/signedUrl/upload-public-document`, form, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
}
///company//l
export const getCompany = () => axiosInstance.get(`${urls.COMPANY_URI}/partnerCompanies`)
export const addCompany = (payload: any) => axiosInstance.post(`${urls.COMPANY_URI}/partnerCompanies`, payload)
export const updateCompany = (id: string, payload: any) => axiosInstance.patch(`${urls.COMPANY_URI}/partnerCompanies/${id}`, payload)
export const uploadCompanyFile = (file: File, docFolder: string, docName: string) => {
  const form = new FormData();
  form.append('file', file);
  form.append('docFolder', docFolder);
  form.append('docName', docName);
  return axiosInstance.post(`${urls.AZURE_URI}/signedUrl/upload-public-document`, form, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
}
export const getCompanyFile = (docFolder: string, docName: string) =>
  axiosInstance.get(`${urls.AZURE_URI}/signedUrl/get-dynamic-document`, {
    params: { docFolder, docName },
    responseType: 'blob'
  });
// Auth service
export const deleteUser = (payload: any) => axiosInstance.delete(`${urls.User_URI}/user/delete-userdata`, { data: payload });
export const deleteBeneficiary = (beneficiaryId: string) => axiosInstance.delete(`${urls.BENEFICIARY_URI}/delete-single-ben/${beneficiaryId}`);

//ops-service//
export const getDashBoardData = (tag: any, from: any, to: any) => axiosInstance.get(`${urls.OPS_URI}/ben-dashboard/getByDate/${tag || null}/${from || null}/${to || null}`);
export const getAmbulanceCoverage = (companyId: string, page: number, limit: number) => axiosInstance.get(`${urls.OPS_URI}/ambulance/${companyId}?pageNo=${page}&limit=${limit}`);
export const downloadAmbulanceCoverage = (companyId: string, payload: any) => axiosInstance.post(`${urls.OPS_URI}/ambulance/download-ambulance-coverage/${companyId}`, payload);
export const downloadAmbulanceCoverageRepostLocally = (docFolder: string, docName: string) => {
  return axiosInstance.get(`${urls.AZURE_URI}/signedUrl/get-dynamic-document?docFolder=${docFolder}&docName=${docName}`, {
    responseType: 'blob'
  })
}
///sasToken//
export const generateSasToken = () => {
  return axiosInstance.get(`${urls.AZURE_URI}/signedUrl/regenerateSaSToken`, {
  })
};
export const fetchDocumentList = (page = 1, limit = 10) => {
  return axiosInstance.get(`${urls.AZURE_URI}/signedUrl/list-folder-files?docFolder=ambulance-coverage-reports&page=${page}&limit=${limit}`, {
  })
};
// Call_Service
export const getAllSlotsHttp = () => {
  return axiosInstance.get(`${urls.CALL_URI}/Roster`, {})
}

export const addAgentToRosterHttp = (id: string, slotId: string, payload: any) => {
  return axiosInstance.post(`${urls.CALL_URI}/Roster/add-agent/${id}/${slotId}`, payload)
}

export const updateAgentRosterHttp = (id: string, payload: any) => {
  return axiosInstance.patch(`${urls.CALL_URI}/Roster/${id}`, payload)

}

export const updateSlotHttp = (id: string, payload: any) => {
  return axiosInstance.patch(`${urls.CALL_URI}/Roster/update-slot/${id}`, payload)

}

export const addSlotHttp = (payload: any) => {
  return axiosInstance.post(`${urls.CALL_URI}/Roster/add-slot`, payload)
}

export const getAllagent = () => {
  return axiosInstance.get(`${urls.CALL_URI}/Roster/get-Agent`)
}

//geocode//
export const getLatLon = (payload: any) => {
  return axiosInstance.post(`${urls.AZURE_URI}/google-map/getgeocode`, payload);
}

/// bulkEmail///
export const getAllEmailJobs = () => axiosInstance.get(`${urls.EMAIL_URI}/bulk-email/get-all-jobs`)
export const getBulkEmailTemplates = () => axiosInstance.get(`${urls.EMAIL_URI}/bulk-email/get-bulk-templates`)
export const getSingleEmailJob = (id: string) => axiosInstance.get(`${urls.EMAIL_URI}/bulk-email/get-job/${id}`)
export const getJobUserDataForBulkEmail = (id: string, page: number, limit: number) => axiosInstance.get(`${urls.EMAIL_URI}/bulk-email/get-job-user-data/${id}?limit=${limit}&page=${page}`)
export const createBulkEmailJob = (jobName: string, payload?: any) => axiosInstance.post(`${urls.EMAIL_URI}/bulk-email/create-job/${jobName}`, payload)
export const updateBulkEmailJob = (jobId: string, payload: any) => axiosInstance.patch(`${urls.EMAIL_URI}/bulk-email/update-job/${jobId}`, payload)
export const addBenToEmailJobHttp = ({ jobId, payload }: { jobId: string, payload: { queryType: QueryType, query: Object } }) => axiosInstance.patch(`${urls.EMAIL_URI}/bulk-email/add-user-job/${jobId}`, payload)
export const sendBulkEmail = (jobId: string) => axiosInstance.post(`${urls.EMAIL_URI}/bulk-email/send-bulk-email/${jobId}`)
export const deleteBulkEmailJobUserData = (jobId: string) => axiosInstance.delete(`${urls.EMAIL_URI}/bulk-email/delete-job-user-data/${jobId}`)
export const deleteInvalidEmailBulkEmailJobUserData = (jobId: string) => axiosInstance.delete(`${urls.EMAIL_URI}/bulk-email/delete-invalid-email-job-user-data/${jobId}`)
export const deleteSingleUserFromBulkEmailUserData = (jobId: string, benId: string) => axiosInstance.delete(`${urls.EMAIL_URI}/bulk-email/delete-user-from-job/${jobId}/${benId}`)

//AmbulanceProviders_Manage
export const createAmbulanceProviders = (providersPayload: any) => axiosInstance.post(`${urls.Hospital_URI}/ambulance-provider`, providersPayload);

export const companyRatecardMapping = (payload: any) => axiosInstance.post(`${urls.Hospital_URI}/company-rate-card-mapping`, payload);
export const setDefaultRateCardMapping = (payload: any) => axiosInstance.post(`${urls.Hospital_URI}/company-rate-card-mapping/default`, payload);

export const getCompanyRateCards = (companyId: string) => axiosInstance.get(`${urls.Hospital_URI}/company-rate-card-mapping/company/${companyId}/rate-cards`);

export const getCompanyAllMappings = (companyId: string) => axiosInstance.get(`${urls.Hospital_URI}/company-rate-card-mapping/company/${companyId}/all-mappings`);

export const deleteCompanyRateCardMapping = (id: string) => axiosInstance.delete(`${urls.Hospital_URI}/company-rate-card-mapping/${id}`);

export const getAllRateCard = () => axiosInstance.get(`${urls.Hospital_URI}/poco-ambulance-rate-card`);
export const createPocoRateCard = (payload: any) => axiosInstance.post(`${urls.Hospital_URI}/poco-ambulance-rate-card`, payload);
export const updatePocoRateCard = (rateCardId: string, payload: any) => axiosInstance.patch(`${urls.Hospital_URI}/poco-ambulance-rate-card/${rateCardId}`, payload);
export const deletePocoRateCard = (rateCardId: string) => axiosInstance.delete(`${urls.Hospital_URI}/poco-ambulance-rate-card/${rateCardId}`);

export const deleteAmbulanceProvider = (providerId: string) => axiosInstance.delete(`${urls.Hospital_URI}/ambulance-provider/${providerId}`);

export const deleteAmbulanceProviderRateCards = (providerId: string) => axiosInstance.delete(`${urls.Hospital_URI}/ambulance-rate-card/deleteByProviderId/${providerId}`);

export const createRateCard = (providersRateCardPayload: any) => axiosInstance.post(`${urls.Hospital_URI}/ambulance-rate-card`, providersRateCardPayload);

export const updateAmbulanceProviders = (providerId: string, payload: any) => axiosInstance.patch(`${urls.Hospital_URI}/ambulance-provider/${providerId}`, payload);

export const updateAmbulanceRateCard = (rateCardId: string, payload: any) => axiosInstance.patch(`${urls.Hospital_URI}/ambulance-rate-card/${rateCardId}`, payload);

export const getAmbulanceProviders = () => axiosInstance.get(`${urls.Hospital_URI}/ambulance-provider`);

export const getProviderCoverageAreas = (providerId: string) => axiosInstance.get(`${urls.Hospital_URI}/ambulance-provider/${providerId}/coverage-areas`);
export const deleteCoverageArea = (coverageAreaId: string) => axiosInstance.delete(`${urls.Hospital_URI}/ambulance-provider/coverage-area/${coverageAreaId}`);
export const updateCoverageArea = (coverageAreaId: string, payload: any) => axiosInstance.patch(`${urls.Hospital_URI}/ambulance-provider/coverage-area/${coverageAreaId}`, payload);

///createAndUpdate
export const createAmbulanceProvidersCities = (citiesPayload: any) => axiosInstance.post(`${urls.Hospital_URI}/ambulance-city`, citiesPayload);

export const getAmbulanceProvidersCities = (providerId: string) => axiosInstance.get(`${urls.Hospital_URI}/ambulance-city/get-provider?provider_id=${providerId}`);

export const deleteAmbulanceProvidersCities = (providerId: string) => axiosInstance.delete(`${urls.Hospital_URI}/ambulance-city/get-provider?provider_id=${providerId}`);

export const removeProviderFromCity = ({ providerId, city }: { providerId: string, city: string }) => axiosInstance.delete(`${urls.Hospital_URI}/ambulance-city/remove-city?city=${city}&providerId=${providerId}`);

export const deleteProviderFromAllCityById = (providerId: string) => axiosInstance.delete(`${urls.Hospital_URI}/ambulance-city/${providerId}`);


export const getRateCardsById = (providerId: any) => axiosInstance.get(`${urls.Hospital_URI}/ambulance-rate-card/${providerId}`);
export const getRateCardsByProviderId = (providerPayload: any) => axiosInstance.post(`${urls.Hospital_URI}/ambulance-rate-card/search`, providerPayload);

export const createBulkQr = (payload: any) => axiosInstance.post(`${urls.OPS_URI}/bulk-qr-ben`, payload);
export const downloadQr = (count: any) => axiosInstance.post(`${urls.OPS_URI}/bulk-qr-ben/export-Qr-Excel`, count, { responseType: 'blob' });

export const getInActiveQrCount = (queries: any) => axiosInstance.get(`${urls.OPS_URI}/bulk-qr-ben/qr-dashboard?query=${queries}`);//need to send queries company=abc&isUsed=true&activeFlag=true&isDownloaded=true

export const getTicketDashboardData = (queryParams: any) => axiosInstance.get(`${urls.Ticket_URI}/ticket/get-ticket-dashboard?${queryParams ? queryParams.toString() : ""
  }`);

export const getAmbulance = (query: string) => axiosInstance.get(`${urls.Ticket_URI}/ambulance/find-with-company-details?${query}`);
export const getTickets = (query: string) => axiosInstance.get(`${urls.Ticket_URI}/ticket/with-location?${query}`);
// Searchbyradius;
export const SearchByRadius = (
  companyId: string | null,
  pageSize: number,
  pageNumber: number,
  radius: number,
  companyName?: string,
  isAllDataRequired?: boolean
) => {
  const params: Record<string, any> = {
    pageSize,
    currentPage: pageNumber,
    radius
  };

  if (companyName) {
    params.companyName = companyName
  }

  if (isAllDataRequired) {
    params.isAllDataRequired = isAllDataRequired
  }

  if (companyId) {
    params.companyId = companyId;
  };

  const queryString = new URLSearchParams(params).toString();
  return axiosInstance.get(`${urls.OPS_URI}/ben-dashboard/without-hospital-report?${queryString}`);
};

export const SearchBenHospital = (
  companyId: string | null,
  pageSize: number,
  pageNumber: number,
  companyName?: string,
  isAllDataRequired?: boolean
) => {
  const params: Record<string, any> = {
    pageSize,
    currentPage: pageNumber,
  };

  if (companyName) {
    params.companyName = companyName
  }

  if (isAllDataRequired) {
    params.isAllDataRequired = isAllDataRequired
  }

  if (companyId) {
    params.companyId = companyId;
  };

  const queryString = new URLSearchParams(params).toString();
  return axiosInstance.get(`${urls.OPS_URI}/ben-dashboard/with-hospital-report?${queryString}`);
};

// Subscriber url
export const updateSubsciberHttp = (id: string, payload: any) => axiosInstance.patch(`${urls.Subscriber_URI}/${id}`, payload)

// Hospital Matching APIs
export const fetchHospitals = (params: {
  page?: number;
  limit?: number;
  status?: string;
  search?: string;
  jobId?: string;
}) => {
  const searchParams = new URLSearchParams();
  if (params.page) searchParams.append('page', params.page.toString());
  if (params.limit) searchParams.append('limit', params.limit.toString());
  if (params.status && params.status !== 'all') searchParams.append('status', params.status);
  if (params.search && params.search.trim()) searchParams.append('q', params.search.trim());
  if (params.jobId) searchParams.append('jobId', params.jobId);
  return axiosInstance.get(`${urls.BACKEND_JOBS_URI}/manual-hospital-matching/hospitals?${searchParams}`);
};

export const updateHospitalField = (id: string, fieldName: string, value: string) =>
  axiosInstance.put(`${urls.BACKEND_JOBS_URI}/manual-hospital-matching/hospitals/${id}`, { [fieldName]: value });

export const changeHospitalStatus = (id: string, status: string, matchedId?: string) => {
  const url = `${urls.BACKEND_JOBS_URI}/manual-hospital-matching/hospitals/change-status/${id}/${status}`;
  const params = matchedId ? { matchedId } : {};
  return axiosInstance.patch(url, {}, { params });
};

export const reprocessHospital = (id: string) =>
  axiosInstance.post(`${urls.BACKEND_JOBS_URI}/manual-hospital-matching/hospitals/${id}/reprocess`);

export const getHospitalStats = (jobId?: string) =>
  axiosInstance.get(`${urls.BACKEND_JOBS_URI}/manual-hospital-matching/stats`, {
    params: jobId ? { jobId } : undefined,
  });

export const getHospitalBatches = (page = 1, limit = 10) =>
  axiosInstance.get(`${urls.BACKEND_JOBS_URI}/manual-hospital-matching/batches`, {
    params: { page, limit },
  });

export const applyInsuranceForBatch = (jobId: string) =>
  axiosInstance.post(`${urls.BACKEND_JOBS_URI}/manual-hospital-matching/batches/${jobId}/apply-insurance`);

export const uploadManualHospitalCsv = (file: File, insuranceName: string) => {
  const form = new FormData();
  form.append('file', file);
  form.append('insuranceName', insuranceName);
  return axiosInstance.post(`${urls.BACKEND_JOBS_URI}/manual-hospital-matching/upload-csv`, form, {
    headers: { 'content-type': 'multipart/form-data' },
  });
};

// Bulk Ops User Data
export const bulkOpsUserData = (payload: FormData) =>
  axiosInstance.post(`${urls.BACKEND_JOBS_URI}/bulk/ops-userdata`, payload, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });

export const getBulkJobStatus = (jobId: string) =>
  axiosInstance.get(`${urls.BACKEND_JOBS_URI}/bulk/ops-job-status/${jobId}`);

export const downloadBulkJobResult = (jobId: string) =>
  axiosInstance.get(`${urls.BACKEND_JOBS_URI}/bulk/ops-job-data/${jobId}`, {
    responseType: 'blob'
  });

export const getOpsJobsByAction = (action: string, page = 1, limit = 10) =>
  axiosInstance.get(`${urls.BACKEND_JOBS_URI}/bulk/ops-jobs?page=${page}&limit=${limit}&action=${action}`);

export const getIndexesByBeneficiaryId = (beneficiaryId: string) => {
  return axiosInstance.get(`${urls.BACKEND_JOBS_URI}/beneficiary-index?beneficiaryId=${beneficiaryId}`);
}

export const getSubscriberIndexesBySubscriberId = (subscriberId: string) => {
  return axiosInstance.get(`${urls.BACKEND_JOBS_URI}/beneficiary-index/average/subscriber/${subscriberId}`);
}
export const getCompanyIndexesByCompany = (companyId: string) => {
  return axiosInstance.get(`${urls.BACKEND_JOBS_URI}/beneficiary-index/average/company/${companyId}`);
}

export const getAmbulanceCountByCompanies = (companyIds: string[]) =>
  axiosInstance.post(`${urls.Ticket_URI}/ticket/ambulance-count/companies`, { companyIds });

export const createDoctor = (payload: any) =>
  axiosInstance.post(`${urls.User_URI}/doctor`, payload);

export const getDoctors = () =>
  axiosInstance.get(`${urls.User_URI}/doctor`);

export const getDoctorDocumentSignedUrl = (docFolder: string, docName: string) =>
  axiosInstance.get(`${urls.AZURE_URI}/signedUrl/get-dynamic-document?docFolder=${docFolder}&docName=${docName}`, {
    responseType: 'blob'
  })

export const getDoctorById = (id: string) =>
  axiosInstance.get(`${urls.User_URI}/doctor/${id}`);

export const verifyActivateDoctor = (id: string) =>
  axiosInstance.patch(`${urls.User_URI}/doctor/${id}/verify`, { status: 'active' });

export const deactivateDoctor = (id: string) =>
  axiosInstance.patch(`${urls.User_URI}/doctor/${id}/verify`, { status: 'inactive' });

export const updateDoctorProfile = (id: string, payload: any) =>
  axiosInstance.patch(`${urls.User_URI}/doctor/${id}/profile`, payload);

export const getDoctorDocuments = (doctorId: string) =>
  axiosInstance.get(`${urls.User_URI}/doctor/${doctorId}/documents`);

export const verifyDoctorDocument = (doctorId: string, documentId: string, is_verified: boolean) =>
  axiosInstance.patch(`${urls.User_URI}/doctor/${doctorId}/documents/${documentId}/verify`, { is_verified });

export const uploadDoctorDocument = (file: File, doctorId: string, docName: string) => {
  const form = new FormData()
  form.append('file', file)
  form.append('docFolder', `doctor-documents/${doctorId}`)
  form.append('docName', docName)
  return axiosInstance.post(`${urls.AZURE_URI}/signedUrl/dynamic-upload-document`, form, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

// Doctor Roster
export const getDoctorRosters = () => axiosInstance.get(`${urls.Hospital_URI}/doctor-rosters`);
export const createDoctorRoster = (payload: any) => axiosInstance.post(`${urls.Hospital_URI}/doctor-rosters`, payload);
export const getDoctorRosterById = (id: string) => axiosInstance.get(`${urls.Hospital_URI}/doctor-rosters/${id}`);
export const getDoctorRosterByDay = (day: string) => axiosInstance.get(`${urls.Hospital_URI}/doctor-rosters/find-by-day?day=${day}`);
export const getCurrentActiveSlot = () => axiosInstance.get(`${urls.Hospital_URI}/doctor-rosters/current-active-slot`);
export const addSlotToDoctorRoster = (id: string, payload: any) => axiosInstance.post(`${urls.Hospital_URI}/doctor-rosters/add-slot/${id}`, payload);
export const updateDoctorRosterSlot = (id: string, payload: any) => axiosInstance.patch(`${urls.Hospital_URI}/doctor-rosters/update-slot/${id}`, payload);
export const addDoctorToSlot = (id: string, slotId: string, payload: any) => axiosInstance.post(`${urls.Hospital_URI}/doctor-rosters/add-doctor/${id}/${slotId}`, payload);
export const updateDoctorRoster = (id: string, payload: any) => axiosInstance.patch(`${urls.Hospital_URI}/doctor-rosters/${id}`, payload);
export const deleteDoctorRoster = (id: string) => axiosInstance.delete(`${urls.Hospital_URI}/doctor-rosters/${id}`);

export const saveDoctorDocument = (payload: { doctorId: string; documentType: string; documentUrl: string }) =>
  axiosInstance.post(`${urls.User_URI}/doctor/${payload.doctorId}/documents`, {
    documents: [{ documentType: payload.documentType, documentUrl: payload.documentUrl }],
  })

export const getHospitalsByNameAndAddress = (payload: any, controller: AbortController) => {
  return axiosInstance.post(
    `${urls.Hospital_URI}/hospital/search-nearby-with-name`,
    payload,
    {
      signal: controller?.signal,
    }
  );
};

export const extensiveSearchHospitals = (payload: {
  searchInput?: string;
  limit?: number;
  page?: number;
  isDeleted?: boolean;
  isEsic?: boolean;
  handleEmergency?: boolean;
  insuranceList?: InsuranceItem[];
}, controller?: AbortController) => {
  return axiosInstance.post(`${urls.Hospital_URI}/hospital/extensive-search`, payload, {
    signal: controller?.signal
  });
};

export const getHospitalCounts = (payload: {
  total?: boolean;
  isDeleted?: boolean;
  isEsic?: boolean;
  handleEmergency?: boolean;
  insuranceList?: InsuranceItem[];
}) => {
  return axiosInstance.post(`${urls.Hospital_URI}/hospital/counts`, payload);
};

export const updateHospital = (id: string, payload: any) => {
  return axiosInstance.patch(`${urls.Hospital_URI}/hospital/${id}`, payload);
};

// Monthly Report
export const generateMonthlyReport = (month: string) =>
  axiosInstance.post(`${urls.BACKEND_JOBS_URI}/monthly-report/generate`, { month })

export const listMonthlyReports = (page = 1, limit = 12) =>
  axiosInstance.get(`${urls.BACKEND_JOBS_URI}/monthly-report?page=${page}&limit=${limit}`)

export const getMonthlyReportStatus = (month: string) =>
  axiosInstance.get(`${urls.BACKEND_JOBS_URI}/monthly-report/${month}`)

export const getMonthlyReportRef = () =>
  axiosInstance.get(`${urls.BACKEND_JOBS_URI}/monthly-report/ref`)

export const getMonthlyReportCaseSheet = (target: string, params: Record<string, any>) =>
  axiosInstance.get(
    isQuarterStr(target)
      ? `${urls.BACKEND_JOBS_URI}/monthly-report/by-quarter/${encodeURIComponent(target)}/case-sheet`
      : `${urls.BACKEND_JOBS_URI}/monthly-report/${target}/case-sheet`,
    { params }
  )

export const getMonthlyReportRows = (month: string, params: Record<string, any>) =>
  axiosInstance.get(`${urls.BACKEND_JOBS_URI}/monthly-report/${month}/rows`, { params })

const isQuarterStr = (str: string) => typeof str === 'string' && /^Q[1-4]/i.test(str.trim())

export const getMonthlyReportPivotCasesByClient = (target: string, params: Record<string, any>) =>
  axiosInstance.get(
    isQuarterStr(target)
      ? `${urls.BACKEND_JOBS_URI}/monthly-report/by-quarter/${encodeURIComponent(target)}/pivot/cases-by-client`
      : `${urls.BACKEND_JOBS_URI}/monthly-report/${target}/pivot/cases-by-client`,
    { params }
  )

export const getMonthlyReportPivotCasesByMonth = (target: string, params: Record<string, any>) =>
  axiosInstance.get(
    isQuarterStr(target)
      ? `${urls.BACKEND_JOBS_URI}/monthly-report/by-quarter/${encodeURIComponent(target)}/pivot/cases-by-month`
      : `${urls.BACKEND_JOBS_URI}/monthly-report/${target}/pivot/cases-by-month`,
    { params }
  )

export const getMonthlyReportPivotTypeOfSupport = (target: string, params: Record<string, any>) =>
  axiosInstance.get(
    isQuarterStr(target)
      ? `${urls.BACKEND_JOBS_URI}/monthly-report/by-quarter/${encodeURIComponent(target)}/pivot/type-of-support`
      : `${urls.BACKEND_JOBS_URI}/monthly-report/${target}/pivot/type-of-support`,
    { params }
  )

export const getMonthlyReportPivotRelationship = (target: string, params: Record<string, any>) =>
  axiosInstance.get(
    isQuarterStr(target)
      ? `${urls.BACKEND_JOBS_URI}/monthly-report/by-quarter/${encodeURIComponent(target)}/pivot/relationship`
      : `${urls.BACKEND_JOBS_URI}/monthly-report/${target}/pivot/relationship`,
    { params }
  )

export const getMonthlyReportPivotMedicalCondition = (target: string, params: Record<string, any>) =>
  axiosInstance.get(
    isQuarterStr(target)
      ? `${urls.BACKEND_JOBS_URI}/monthly-report/by-quarter/${encodeURIComponent(target)}/pivot/medical-condition`
      : `${urls.BACKEND_JOBS_URI}/monthly-report/${target}/pivot/medical-condition`,
    { params }
  )

export const getMonthlyReportPivotRtCategory = (target: string, params: Record<string, any>) =>
  axiosInstance.get(
    isQuarterStr(target)
      ? `${urls.BACKEND_JOBS_URI}/monthly-report/by-quarter/${encodeURIComponent(target)}/pivot/rt-category`
      : `${urls.BACKEND_JOBS_URI}/monthly-report/${target}/pivot/rt-category`,
    { params }
  )

export const getMonthlyReportPivotRtClients = (target: string, params: Record<string, any>) =>
  axiosInstance.get(
    isQuarterStr(target)
      ? `${urls.BACKEND_JOBS_URI}/monthly-report/by-quarter/${encodeURIComponent(target)}/pivot/rt-clients`
      : `${urls.BACKEND_JOBS_URI}/monthly-report/${target}/pivot/rt-clients`,
    { params }
  )

export const getMonthlyReportPivotSlaCompliance = (target: string, params: Record<string, any>) =>
  axiosInstance.get(
    isQuarterStr(target)
      ? `${urls.BACKEND_JOBS_URI}/monthly-report/by-quarter/${encodeURIComponent(target)}/pivot/sla-compliance`
      : `${urls.BACKEND_JOBS_URI}/monthly-report/${target}/pivot/sla-compliance`,
    { params }
  )



// CHI MIS Report
export const listChiMisReports = (page = 1, limit = 24) =>
  axiosInstance.get(`${urls.BACKEND_JOBS_URI}/monthly-report/chi-mis?page=${page}&limit=${limit}`)

export const getChiMisReport = (month: string) =>
  axiosInstance.get(`${urls.BACKEND_JOBS_URI}/monthly-report/chi-mis/${month}`)

export const generateChiMisReport = (month: string) =>
  axiosInstance.post(`${urls.BACKEND_JOBS_URI}/monthly-report/chi-mis/generate`, { month })

// Campaign Analytics - Timeline
export const getCampaignTicketTimeline = (params: {
  startDate: string;
  endDate: string;
  companyId?: string;
}) => axiosInstance.get(`${urls.OPS_URI}/campaign-analytics/timeline`, { params });

// (i)////graphQL
export const client = new ApolloClient({
  uri: `${urls.GRAPHQL_URI}`,
  cache: new InMemoryCache(),
  defaultOptions: {
    query: {
      fetchPolicy: 'network-only', // This ensures that queries always fetch from the network, not from the cache
      errorPolicy: 'all', // This will make sure all errors are handled and won't crash your app
    },
  },
})

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    console.log('error:', error);
    const originalRequest = error.config;

    if (
      error.response &&
      error.response.status === 401 &&
      originalRequest &&
      !originalRequest._isRetry
    ) {
      originalRequest._isRetry = true;
      try {

        // Attempt to refresh the access token using a POST request to refresh endpoint
        const res = await axios.post(
          `${urls.User_URI}/auth/poco-user-refresh-token`,
          {},
          {
            withCredentials: true, // Ensure credentials are sent with the refresh token request
          }
        );
        if (res?.data?.userRole === "POCO_EMPLOYEE_AGENT") {
          window.location.href = "/login";
        }
        // Retry the original request
        return axiosInstance(originalRequest);
      } catch (err) {
        console.log('err:', err);
        // Handle errors that occur during the refresh token request
        // console.log('err:', err);
        // localStorage.setItem("isLogin", "false");
        // window.location.reload();
        window.location.href = "/login";
        // const localStorageUpdatedEvent = new Event("localStorageUpdated");
        // window.dispatchEvent(localStorageUpdatedEvent);
        // Redirect to login page, show an error message, or handle as appropriate
        // throw err; // Throw the error to indicate that the request failed
      }
      // localStorage.setItem("isLogin", "false");
      window.location.href = "/login";
      // window.location.reload();
    }
    // For other errors, just throw the error to be handled by the caller
    throw error;
  }
);

export default axiosInstance;

// ─── Insurance Reconciliation ─────────────────────────────────────────────────

export const irCreateJob = (file: File, insuranceName: string) => {
  const form = new FormData();
  form.append('file', file);
  form.append('insuranceName', insuranceName);
  return axiosInstance.post(`${urls.BACKEND_JOBS_URI}/insurance-reconciliation/job`, form, {
    headers: { 'content-type': 'multipart/form-data' },
  });
};

export const irGetJobs = (page = 1, limit = 10) =>
  axiosInstance.get(`${urls.BACKEND_JOBS_URI}/insurance-reconciliation/job`, {
    params: { page, limit },
  });

export const irGetJob = (jobId: string) =>
  axiosInstance.get(`${urls.BACKEND_JOBS_URI}/insurance-reconciliation/job/${jobId}`);

export const irGetRows = (
  jobId: string,
  params: { aiDecision?: string; page?: number; limit?: number },
) =>
  axiosInstance.get(`${urls.BACKEND_JOBS_URI}/insurance-reconciliation/job/${jobId}/rows`, {
    params,
  });

export const irSubmitDecision = (
  rowId: string,
  payload: { decision: 'matched' | 'rejected'; agentNote?: string; matchedHospitalId?: string },
) =>
  axiosInstance.patch(
    `${urls.BACKEND_JOBS_URI}/insurance-reconciliation/row/${rowId}/decision`,
    payload,
  );

export const irApplyJob = (jobId: string) =>
  axiosInstance.post(`${urls.BACKEND_JOBS_URI}/insurance-reconciliation/job/${jobId}/apply`, {});

// ─── CHI Data Tracking (reads carebulkdatas collection) ──────────────────────

/** Paginated list of CHI care jobs (POCO_EMPLOYEE_ADMIN). */
export const getChiJobsList = (page = 1, limit = 10, companyId?: string) => {
  const params: Record<string, any> = { page, limit };
  if (companyId) params.companyId = companyId;
  return axiosInstance.get(`${urls.BACKEND_JOBS_URI}/bulk/care-jobs`, { params });
};

/** Real-time status for a single CHI care job (POCO_EMPLOYEE_ADMIN). */
export const getChiOpsJobStatus = (jobId: string) =>
  axiosInstance.get(`${urls.BACKEND_JOBS_URI}/bulk/care-job-status/${jobId}`);

/** Download CSV result for a completed CHI care job (POCO_EMPLOYEE_ADMIN). */
export const downloadChiJobResult = (jobId: string) =>
  axiosInstance.get(`${urls.BACKEND_JOBS_URI}/bulk/care-job-data/${jobId}`, {
    responseType: 'blob',
  });
